import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { getLanguage } from './i18n/locale';
import './index.css';

// index.html ships lang="en"; most users read Alma in German. The lang
// attribute drives screen-reader pronunciation, hyphenation and the date
// picker's locale, so set it from the resolved UI language before render.
document.documentElement.lang = getLanguage();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
